import { Eye, EyeOff } from "lucide-react";
import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { login } from "../api";
import { AuthContext } from "../AuthContext";
import { jwtDecode } from "jwt-decode";

export default function Login() {
  const { setUser } = useContext(AuthContext);
  const [loginInput, setLoginInput] = useState("");
  const [senha, setSenha] = useState("");
  const [mostrarSenha, setMostrarSenha] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  async function handleSubmit(e) {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const data = await login(loginInput, senha);
      localStorage.setItem("token", data.token);
      localStorage.setItem("refresh_token", data.refresh_token);
      const decoded = jwtDecode(data.token);
      setUser({ token: data.token, refresh: data.refresh_token, ...decoded });
      navigate("/dashboard");
    } catch (err) {
      console.error(err);
      setError(err.message || "Erro ao fazer login.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="login-container">
      <div className="login-card">
        <h2>BES</h2>
        <p className="subtitle">Faça login para continuar</p>

        {error && <p className="error-msg">{error}</p>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Email ou Nome</label>
            <input
              type="text"
              placeholder="Digite seu email ou nome"
              value={loginInput}
              onChange={(e) => setLoginInput(e.target.value)}
              required
            />
          </div>

          {/* Campo de senha com ícone no canto direito */}
          <div className="form-group senha-group">
            <label>Senha</label>
            <div className="senha-wrapper">
              <input
                type={mostrarSenha ? "text" : "password"}
                placeholder="Digite sua senha"
                value={senha}
                onChange={(e) => setSenha(e.target.value)}
                required
              />
              <button
                type="button"
                className="toggle-senha-btn"
                onClick={() => setMostrarSenha(!mostrarSenha)}
                aria-label={mostrarSenha ? "Ocultar senha" : "Mostrar senha"}
              >
                {mostrarSenha ? <EyeOff size={20} /> : <Eye size={20} />}
              </button>
            </div>
          </div>

          <button type="submit" className="btn-primary" disabled={loading}>
            {loading ? <span className="spinner"></span> : "Entrar"}{" "}
            {loading && "Entrando..."}
          </button>
        </form>
      </div>
    </div>
  );
}
